import { Paper } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import {
  StyledComponentProps,
  StyleRulesCallback,
  Theme,
  withStyles,
} from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import * as React from "react";

import { getDocumentationUrl } from "../api";
import Container from "./Container";

interface State {
  token: string | null;
}

class Documentation extends React.Component<StyledComponentProps, State> {
  public state = { token: null };

  public async componentDidMount() {
    const token = await localStorage.getItem("login");
    this.setState({ token });
  }

  public render() {
    const { classes } = this.props;

    return (
      <Container>
        <Grid container={true} spacing={2}>
          <Grid item={true} xs={12}>
            <Paper className={classes && classes.paper}>
              <Grid container={true} spacing={2}>
                <Grid item={true} xs={12}>
                  <Typography variant="h6">Dokumentation</Typography>
                </Grid>
              </Grid>
              <Grid container={true} spacing={2} justify="space-evenly">
                <Grid item={true}>
                  <Button
                    variant="contained"
                    href={
                      getDocumentationUrl() +
                      `/documentation-frontend-current.pdf?token=${this.state.token}`
                    }
                  >
                    Download Anwenderdokumentation
                  </Button>
                </Grid>
                <Grid item={true}>
                  <Button
                    variant="contained"
                    href={
                      getDocumentationUrl() +
                      `/documentation-backend-current.pdf?token=${this.state.token}`
                    }
                  >
                    Download Backend Dokumentation
                  </Button>
                </Grid>
              </Grid>
            </Paper>
          </Grid>
        </Grid>
      </Container>
    );
  }
}

const styles: StyleRulesCallback<Theme, State> = (theme: Theme) => ({
  paper: {
    padding: theme.spacing(4),
  },
});

export default withStyles(styles)(Documentation);



// WEBPACK FOOTER //
// ./src/components/Documentation.tsx